import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Identificas',
  desc: 'Usas el Semáforo Sensorial para detectar la crisis 2 minutos antes de que estalle.'
}, {
  num: '2',
  title: 'Anclas',
  desc: 'Aplicas la técnica de presión física y el guion de una sola palabra.'
}, {
  num: '3',
  title: 'Extraes',
  desc: 'Sigues el plan de salida segura para recuperar la paz en tiempo récord.'
}];
export function HowItWorks() {
  return <section className="bg-[#f0e9df] py-24 px-6" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-123">
            Cómo funciona el método
          </h2>
          <p className="text-lg text-gray-700" data-id="element-124">
            Tres pasos simples diseñados para una mamá bajo estrés.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-125">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-copper/30 z-0" data-id="element-126"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-127">
              <div className="w-24 h-24 bg-navy text-copper rounded-full flex items-center justify-center text-4xl font-serif font-bold mb-6 shadow-lg border-4 border-[#f0e9df]" data-id="element-128">
                {step.num}
              </div>
              <h3 className="text-2xl font-serif font-bold text-navy mb-3" data-id="element-129">
                {step.title}
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-130">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}